import React, { useEffect, useMemo, useState } from 'react';
import EmptyState from '../EmptyState';
import { connect } from 'react-redux';
import _ from 'lodash';
import { IconContext } from 'react-icons';
import {
  sneakerDefectsCondition,
  dustBag,
  boxHandbag,
  formatCurrency,
} from 'utils';
import {
  sneakersCondition,
  boxCondition,
  accessoriesCondition,
  yellowing,
  displayItem,
  sneakersDefect,
  handbagCondition,
  getImageCategory,
  handleStatusConsignment,
  handleColorStatusConsignment,
} from 'utils/Helpers';
import MoreIcon from 'images/more.png';
import ReactLoading from 'react-loading';
import ModalPending from '../Modals/ModalPending';
import ModalActive from '../Modals/ModalActive';
import ModalInProgress from '../Modals/ModalInProgress';
import ModalHistory from '../Modals/ModalHistory';
import { ModalShipper } from '../../../../../../../components/Modals';
import ModalTracking from '../Modals/ModalTracking';
import { Row } from 'antd';
import Style from './TabContent.module.scss';
import classNames from 'classnames';
import { useGetViewType } from 'Pages/Home/Hooks/useGetViewType';
import useReceivePackage from 'Pages/UserDashboard/Consignment/Hooks/useReceivePackage';
import { toast } from 'react-toastify';
import {
  ETabKeys,
  NSConsignment,
} from 'Pages/UserDashboard/Consignment/Consignment.d';

interface ITabContentProps {
  dataSource: any[];
  isFetching?: boolean;
  type: string;
  ratio: number;
  currency: string;
  refresh: () => void;
  onChangeTab: (param: NSConsignment.TTabKeys) => void;
}

const TabContent: React.FC<ITabContentProps> = (props) => {
  const [selectedData, setSelectedData] = useState<any>({});
  const [isModalOpened, setModalOpened] = useState(false);
  const [isFetchingModal, setFetchingModal] = useState(false);
  const [isClickedFromList, setIsClickedFromList] = useState(false);
  const { isDesktopView, isMobileView } = useGetViewType();

  // ============== Start of displaying delivery method modal ==============
  const [isModalAWBOpened, setModalAWBOpened] = useState(false);

  const onClickDeliveryMethod = (data) => {
    setModalAWBOpened(true);
    setSelectedData(data);
    setModalOpened(false);
  };

  const onHideModalAwb = () => {
    setModalAWBOpened(false);
    setModalOpened(true);
    setFetchingModal(true);
    refresh();
    if (isClickedFromList) {
      setIsClickedFromList(false);
      return;
    }
  };

  const onSubmitDropOff = () => {
    setModalAWBOpened(false);
    setFetchingModal(true);
    refresh();
    if (isClickedFromList) {
      setIsClickedFromList(false);
      return;
    }
  };

  const getShipperDetails = () => {
    try {
      if (!selectedData.hasOwnProperty('sell_consignments')) return null;
      if (!selectedData.sell_consignments) return null;

      return selectedData.sell_consignments.shipper;
    } catch (err) {
      console.log(
        err,
        'Error fn shipperDataHandler file Consignment/TabContent',
      );
      return null;
    }
  };

  const onClickReceivePackage = async (data) => {
    if (isLoadingReceivePackage) {
      return;
    }

    const result = await receivePackage(data?.sell_consignments?.id);

    if (!result.isSuccess) {
      toast.error(result.message, {
        position: 'top-right',
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
      });
      return;
    }

    toast.success(result.message, {
      position: 'top-right',
      autoClose: 5000,
      closeOnClick: true,
      pauseOnHover: true,
    });

    props.onChangeTab(ETabKeys.History);
  };
  // ============== End of displaying delivery method modal ==============

  // ============== Start of displaying tracking modal ==============
  const [isModalTrackingOpened, setModalTrackingOpened] = useState(false);

  const onClickTrackingPackage = (data) => {
    setModalTrackingOpened(true);
    setSelectedData(data);
    setModalOpened(false);
  };

  const onHideModalTracking = () => {
    setModalTrackingOpened(false);
    setModalOpened(true);
    if (isClickedFromList) {
      setIsClickedFromList(false);
      return;
    }
  };
  // ============== End of displaying tracking modal ==============

  const { dataSource, isFetching, refresh, type, ratio, currency } = props;

  useEffect(() => {
    if (!isFetching) {
      setFetchingModal(false);
    }
  }, [isFetching]);

  const { post: receivePackage, isPosting: isLoadingReceivePackage } =
    useReceivePackage();

  const isEmpty = useMemo(() => {
    return !dataSource.length;
  }, [dataSource]);

  useEffect(() => {
    // update selecteddata based on dataSource change
    if (!selectedData?.id) return;
    const newData = dataSource.find((item) => item.id === selectedData.id);
    setSelectedData(newData);
  }, [dataSource]);

  const renderConsignmentStatusDesktop = (status, item) => {
    const isShipper = item?.sell_consignments?.shipper;
    const isShowTrackPackage =
      isShipper && ['En Route to Kick Avenue'].includes(status);
    const isShowPackageReceived = ['On The Way To You'].includes(status);

    const isShowSelectDeliveryMethod = ['Consignment Approved'].includes(
      status,
    );

    return (
      <Row>
        <p className={'status-text'}>{status}</p>
        {isShowPackageReceived && (
          <div
            className={Style['button']}
            onClick={() => onClickReceivePackage(item)}
          >
            {isLoadingReceivePackage ? 'Submitting...' : 'Package Received'}
          </div>
        )}
        {isShowTrackPackage && (
          <div
            className={Style['button']}
            onClick={() => {
              setIsClickedFromList(true);
              onClickTrackingPackage(item);
            }}
          >
            Track Package
          </div>
        )}
        {isShowSelectDeliveryMethod && (
          <div
            className={Style['button']}
            onClick={() => {
              setIsClickedFromList(true);
              onClickDeliveryMethod(item);
            }}
          >
            Select Delivery Method
          </div>
        )}
      </Row>
    );
  };

  const renderConsignmentStatusMobile = (status) => {
    return (
      <p
        className={'status-text'}
        style={{ color: '#242424', textTransform: 'uppercase' }}
      >
        {status}
      </p>
    );
  };

  const renderConsignmentButtonMobile = (status, item) => {
    const isShipper = item?.sell_consignments?.shipper;
    const isShowTrackPackage =
      isShipper && ['En Route to Kick Avenue'].includes(status);
    const isShowPackageReceived = ['On The Way To You'].includes(status);

    const isShowSelectDeliveryMethod = ['Consignment Approved'].includes(
      status,
    );
    return (
      <React.Fragment>
        {isShowPackageReceived && (
          <div
            className={Style['button']}
            onClick={() => onClickReceivePackage(item)}
          >
            {isLoadingReceivePackage ? 'Submitting...' : 'Package Received'}
          </div>
        )}
        {isShowTrackPackage && (
          <div
            className={Style['button']}
            onClick={() => {
              setIsClickedFromList(true);
              onClickTrackingPackage(item);
            }}
          >
            Track Package
          </div>
        )}
        {isShowSelectDeliveryMethod && (
          <div
            className={Style['button']}
            onClick={() => {
              setIsClickedFromList(true);
              onClickDeliveryMethod(item);
            }}
          >
            Select Delivery Method
          </div>
        )}
      </React.Fragment>
    );
  };

  const renderItem = (item) => {
    const isDefects = item?.defects?.length > 0;
    const uniqueDefects = _.uniqBy(isDefects ? item?.defects : null, 'name');
    const dustBagCondition = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'DUST_BAG' && a.value)
      : {};
    const boxConditions = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'BOX')
      : {};
    const hideBoxInfo = item?.product_variant?.hide_box_info;
    const isVintage = item?.product_variant?.vintage;
    const sneakersDetailArr = [
      isVintage ? 'Vintage' : sneakersCondition(item?.sneakers_condition),
      hideBoxInfo ? '' : boxCondition(item?.box_condition),
      accessoriesCondition(item?.missing_accessories),
      yellowing(item?.yellowing),
      displayItem(item?.display_item),
      sneakersDefect(item?.sneakers_defect),
      isDefects ? sneakerDefectsCondition(uniqueDefects) : '',
    ];
    const sneakersDetail = sneakersDetailArr
      .filter((item) => item !== '')
      .map((item) => item)
      .join(' / ');
    const luxuryDetailArr = [
      sneakersCondition(item?.sneakers_condition),
      accessoriesCondition(item?.missing_accessories),
      dustBag(dustBagCondition),
      hideBoxInfo ? '' : boxHandbag(boxConditions),
      isDefects ? handbagCondition(uniqueDefects) : '',
    ];
    const luxuryDetail = luxuryDetailArr
      .filter((item) => item !== '' && item !== 'Missing Box')
      .map((item) => item)
      .join(' / ');

    const category = item.user_sell
      ? item?.user_sell?.product_variant?.product?.category?.name
      : item?.product_variant?.product?.category?.name;
    const brandName = item.user_sell
      ? item?.user_sell?.product_variant?.product?.brand?.name
      : item?.product_variant?.product?.brand?.name;
    const displayName = item.user_sell
      ? item?.user_sell?.product_variant?.display_name
      : item?.product_variant?.display_name;
    const sizeUs = item.sale
      ? item?.sale[0]?.sale_product?.size?.US
      : item?.size?.US;
    const consignmentId = item.sale
      ? item?.sale[0]?.sale_product?.consignment_id
      : item?.consignment_id;
    const productPrice = item.sale ? item?.sale[0]?.price : item?.asking_price;
    const invoiceNumber = item.invoice_number ? item.invoice_number : '-';
    const orderId = item.offer ? item.offer[0]?.invoice_number : '-';
    const status = handleStatusConsignment(item, type);
    const hypequarterDisplay = item?.user_sell?.hypequarter_display;

    const handleClickedDetail = () => {
      setSelectedData(item);
      setModalOpened(true);
    };

    const priceColor = () => {
      const color = handleColorStatusConsignment(status);
      if (!color) {
        return {};
      }

      return { color };
    };

    if (isDesktopView) {
      return (
        <div className={`item-table`} key={item.id}>
          <div
            className={classNames(
              'product-container selling',
              Style['product-container'],
            )}
          >
            <img
              src={getImageCategory(category.toLowerCase())}
              className={'image-category'}
            />
            <div>
              <p className={'title'}>{brandName}</p>
              <p className={'content'}>{displayName}</p>
              {category === 'handbags' ||
              (category === 'lifestyles' &&
                sizeUs.toLowerCase() !== 'all size') ? (
                <div className={'content'}>
                  <p>{sizeUs}</p>
                </div>
              ) : (
                <div className={'content'}>
                  <p>US {sizeUs}</p>
                </div>
              )}
              <p className={'content'}>
                {category !== 'handbags' ? sneakersDetail : luxuryDetail}
              </p>
              <p className={'content'}>CG-ID: {consignmentId}</p>
              {type === 'in_progress' ? (
                <p className={'content'}>Order-ID: {invoiceNumber}</p>
              ) : type === 'history' && status === 'Completed' ? (
                <p className={'content'}>Order-ID: {orderId}</p>
              ) : null}
              {item.user_sell
                ? hypequarterDisplay && (
                    <div className={'hq-wrapper'}>
                      <p className={'hq-text'}>Hypequarter Display</p>
                    </div>
                  )
                : item.hypequarter_display
                ? item.hypequarter_display && (
                    <div className={'hq-wrapper'}>
                      <p className={'hq-text'}>Hypequarter Display</p>
                    </div>
                  )
                : null}
            </div>
          </div>
          <div className={'price-container'}>
            <p className={'price'} style={priceColor()}>
              {formatCurrency(productPrice, ratio, currency)}
            </p>

            {status === 'Waiting in Line' && (
              <React.Fragment>
                <div className={'box'}>
                  <p className={'lowest'} style={{ fontWeight: 'bold' }}>
                    Lowest Ask
                  </p>
                  <p className={'price'} style={{ fontWeight: 'bold' }}>
                    {formatCurrency(item?.lowest_ask, ratio, currency)}
                  </p>
                </div>

                {item?.highest_bid && (
                  <div className={'box'}>
                    <p className={'lowest'} style={{ fontWeight: 'bold' }}>
                      Highest Offer
                    </p>
                    <p className={'price'} style={{ fontWeight: 'bold' }}>
                      {formatCurrency(
                        item.highest_bid?.amount,
                        ratio,
                        currency,
                      )}
                    </p>
                  </div>
                )}
              </React.Fragment>
            )}

            {status === 'Active Consignment' && item?.highest_bid && (
              <div className={'box'}>
                <p className={'lowest'} style={{ fontWeight: 'bold' }}>
                  Highest Offer
                </p>
                <p className={'price'} style={{ fontWeight: 'bold' }}>
                  {formatCurrency(item.highest_bid?.amount, ratio, currency)}
                </p>
              </div>
            )}
          </div>
          <div
            className={classNames(
              'expiry-container',
              Style['action-container'],
            )}
          >
            {renderConsignmentStatusDesktop(status, item)}
            <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
              <div className={'icon-container'} onClick={handleClickedDetail}>
                <img src={MoreIcon} alt="..." />
              </div>
            </IconContext.Provider>
          </div>
        </div>
      );
    }

    return (
      <div className={`item-table`} key={item.id}>
        <div className={Style['product-container']}>
          <div className={classNames('product-container selling')}>
            <img
              src={getImageCategory(category.toLowerCase())}
              className={'image-category'}
            />
            <div>
              <p className={'title'}>{brandName}</p>
              <p className={'content'}>{displayName}</p>
              {category === 'handbags' ||
              (category === 'lifestyles' &&
                sizeUs.toLowerCase() !== 'all size') ? (
                <div className={'content'}>
                  <p>{sizeUs}</p>
                </div>
              ) : (
                <div className={'content'}>
                  <p>US {sizeUs}</p>
                </div>
              )}
              <p className={'content'}>
                {category !== 'handbags' ? sneakersDetail : luxuryDetail}
              </p>
              <p className={'content'}>CG-ID: {consignmentId}</p>
              {type === 'in_progress' ? (
                <p className={'content'}>Order-ID: {invoiceNumber}</p>
              ) : type === 'history' && status === 'Completed' ? (
                <p className={'content'}>Order-ID: {orderId}</p>
              ) : null}
              {item.user_sell
                ? hypequarterDisplay && (
                    <div className={'hq-wrapper'}>
                      <p className={'hq-text'}>Hypequarter Display</p>
                    </div>
                  )
                : item.hypequarter_display
                ? item.hypequarter_display && (
                    <div className={'hq-wrapper'}>
                      <p className={'hq-text'}>Hypequarter Display</p>
                    </div>
                  )
                : null}
            </div>
          </div>
        </div>

        <div className={Style['price-container']}>
          <div className={'price-container'}>
            {renderConsignmentStatusMobile(status)}

            <p className={'price'} style={priceColor()}>
              {formatCurrency(productPrice, ratio, currency)}
            </p>

            {status === 'Waiting in Line' && (
              <React.Fragment>
                <div className={'box'}>
                  <p className={'lowest'} style={{ fontWeight: 'bold' }}>
                    Lowest Ask
                  </p>
                  <p className={'price'} style={{ fontWeight: 'bold' }}>
                    {formatCurrency(item?.lowest_ask, ratio, currency)}
                  </p>
                </div>

                {item?.highest_bid && (
                  <div className={'box'}>
                    <p className={'lowest'} style={{ fontWeight: 'bold' }}>
                      Highest Offer
                    </p>
                    <p className={'price'} style={{ fontWeight: 'bold' }}>
                      {formatCurrency(
                        item.highest_bid?.amount,
                        ratio,
                        currency,
                      )}
                    </p>
                  </div>
                )}
              </React.Fragment>
            )}

            {status === 'Active Consignment' && item?.highest_bid && (
              <div className={'box'}>
                <p className={'lowest'} style={{ fontWeight: 'bold' }}>
                  Highest Offer
                </p>
                <p className={'price'} style={{ fontWeight: 'bold' }}>
                  {formatCurrency(item.highest_bid?.amount, ratio, currency)}
                </p>
              </div>
            )}

            {renderConsignmentButtonMobile(status, item)}
          </div>
        </div>

        <div className={Style['action-container']}>
          <div className={classNames('expiry-container')}>
            <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
              <div className={'icon-container'} onClick={handleClickedDetail}>
                <img src={MoreIcon} alt="..." />
              </div>
            </IconContext.Provider>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={classNames('table-container', Style['tab-content'])}>
      {isDesktopView && (
        <div className={'header-table'}>
          <div
            className={classNames(
              'product-container',
              Style['product-container'],
            )}
          >
            <span>Product</span>
          </div>
          <div className={'price-container'}>
            <span>Price</span>
          </div>
          <div
            className={classNames(
              'expiry-container',
              Style['action-container'],
            )}
          >
            <span>Status/Action</span>
          </div>
        </div>
      )}

      {isMobileView && (
        <div className={'header-table'}>
          <div className={Style['product-container']}>
            <div className={'product-container'}>
              <span>Product</span>
            </div>
          </div>
          <div className={Style['price-container']}>
            <div className={'price-container'}>
              <span>Status</span>
            </div>
          </div>
          <div className={Style['action-container']}></div>
        </div>
      )}
      <div className={'body-table'}>
        {isFetching && (
          <div className={'empty-container'}>
            <ReactLoading
              type={'spin'}
              height={50}
              width={50}
              color={'#159953'}
            />
          </div>
        )}

        {!isFetching && (
          <React.Fragment>
            {isEmpty && <EmptyState refresh={refresh} type={type} />}
            {!isEmpty && dataSource?.map((item) => renderItem(item))}
          </React.Fragment>
        )}
      </div>

      {type === 'pending' && isModalOpened && (
        <ModalPending
          isOpen={isModalOpened}
          onToggle={() => setModalOpened(false)}
          data={selectedData}
          onClickDeliveryMethod={(data) => onClickDeliveryMethod(data)}
          onClickTrackingShipper={(data) => onClickDeliveryMethod(data)}
          onClickTrackingPackage={(data) => onClickTrackingPackage(data)}
          type={type}
          onClickReceivePackage={(data) => onClickReceivePackage(data)}
          isFetchingModal={isFetchingModal}
        />
      )}
      {type === 'active' && (
        <ModalActive
          isOpen={isModalOpened}
          onToggle={() => setModalOpened(false)}
          data={selectedData}
          callbackAfterUpdate={refresh}
          type={type}
        />
      )}
      {type === 'in_progress' && (
        <ModalInProgress
          isOpen={isModalOpened}
          onToggle={() => setModalOpened(false)}
          data={selectedData}
          type={type}
        />
      )}
      {type === 'history' && (
        <ModalHistory
          isOpen={isModalOpened}
          onToggle={() => setModalOpened(false)}
          data={selectedData}
          type={type}
        />
      )}

      {isModalAWBOpened ? (
        <ModalShipper
          isConsignments
          isOpen={isModalAWBOpened}
          ratio={ratio}
          currency={currency}
          seller_responded={
            selectedData.hasOwnProperty('sell_consignments')
              ? selectedData.sell_consignments.seller_responded
              : ''
          }
          submitDropoff={() => onSubmitDropOff()}
          onHideAndUpdate={() => onHideModalAwb()}
          onHide={() => onHideModalAwb()}
          sale_id={
            selectedData.hasOwnProperty('sell_consignments')
              ? selectedData.sell_consignments.id
              : 0
          }
          shipperData={getShipperDetails()}
        />
      ) : null}
      {isModalTrackingOpened ? (
        <ModalTracking
          data={selectedData?.sell_consignments?.shipper}
          onToggle={() => onHideModalTracking()}
          isOpen={isModalTrackingOpened}
          callback={refresh}
          onToggleParent={() => setModalOpened(false)}
        />
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    currency: state.dataAuth.userCurrency.currency,
    ratio: state.dataAuth.userCurrency.ratio,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(TabContent);
